module.exports = __webpack_public_path__ + "static/media/xambe.bb315688.png";